<button
  type="button"
  class="button--sm button-block"
  (click)="updateItemAsync()"
  [class.button-primary]="!tool.addedToPO"
  [class.button-remove]="tool.addedToPO"
  [disabled]="!toolService.canAddToPO(tool)">
  <span
    *ngIf="!tool.addedToPO"
    class="flex middle center">
    <mat-icon svgIcon="purchase"></mat-icon>
    <span class="button__label">{{ "button.purchaseorder" | translate }}</span></span
  >
  <span
    *ngIf="tool.addedToPO"
    class="flex middle center">
    <mat-icon svgIcon="purchase"></mat-icon>
    <span class="button__label">{{ "button.removefrompo" | translate }}</span>
  </span>
</button>
